import * as React from 'react';

export default function IconConnectWithGoogle({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <g fillRule="evenodd" clipPath="url(#a)" clipRule="evenodd">
        <path
          fill="#FBBC05"
          d="M3.442 8c0-.508.085-.995.235-1.452L1.041 4.535A7.819 7.819 0 0 0 .238 8c0 1.246.289 2.42.802 3.463l2.635-2.017A4.628 4.628 0 0 1 3.442 8Z"
        />
        <path
          fill="#EB4335"
          d="M8.071 3.378c1.104 0 2.1.39 2.884 1.03l2.279-2.275C11.845.924 10.065.178 8.071.178a7.81 7.81 0 0 0-7.03 4.357l2.636 2.013a4.616 4.616 0 0 1 4.394-3.17Z"
        />
        <path
          fill="#34A853"
          d="M8.071 12.621a4.616 4.616 0 0 1-4.394-3.17l-2.636 2.013a7.81 7.81 0 0 0 7.03 4.357c1.91 0 3.735-.678 5.104-1.95l-2.503-1.934c-.706.445-1.595.684-2.6.684Z"
        />
        <path
          fill="#4285F4"
          d="M15.549 8c0-.462-.072-.96-.178-1.422h-7.3V9.6h4.202c-.21 1.03-.782 1.823-1.6 2.338l2.502 1.935C14.613 12.538 15.55 10.55 15.55 8Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
